export default __webpack_public_path__ + "static/media/textBinIconDark.73d371c8.svg";